import { useRouter } from 'next/router';
import React from 'react';
import { connect } from 'unistore/react';

import UpdateHeaderMain from './main';

// import IfElse from '../IfElse';

const UpdateHeader = connect('isNotFlagged, headerUpdates, selectedCountry')(
	props => {
		const { asPath } = useRouter();

		const country = asPath.split('/')[1];

		return country === 'tr' ||
			(props.isNotFlagged &&
				typeof props.headerUpdates === 'undefined') ? null : (
			<UpdateHeaderMain {...props} />
		);
	}
);

export default UpdateHeader;
